import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import { useApiLoadingStore } from "../store/useApiLoadingStore";

const baseURL = import.meta.env.VITE_API_URL;

const api = axios.create({ baseURL });
const plainApi = axios.create({ baseURL });

const getIdToken = async () => {
  let token = document.cookie.split("idToken=")[1]?.split(";")[0];
  // check if token is expired
  if (token) {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (Date.now() >= payload.exp * 1000) {
      const session = await fetchAuthSession();
      token = session.tokens?.idToken ? session.tokens.idToken.toString() : "";
    }
  }
  return token;
};

// Global loading: increment on request, decrement on response/error
const bindApiLoading = (instance: typeof api) => {
  instance.interceptors.request.use((config) => {
    useApiLoadingStore.getState().increment();
    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      useApiLoadingStore.getState().decrement();
      return response;
    },
    (error) => {
      useApiLoadingStore.getState().decrement();
      return Promise.reject(error);
    },
  );
};

bindApiLoading(api);
bindApiLoading(plainApi);

api.interceptors.request.use(
  async (config) => {
    try {
      const idToken = await getIdToken();
      if (idToken) {
        config.headers.Authorization = `Bearer ${idToken}`;
        const { useOrganizationStore } = await import(
          "../store/useOrganizationStore"
        );
        const activeOrgId = useOrganizationStore.getState().activeOrgId;
        if (activeOrgId) {
          config.headers["X-Organization-Id"] = activeOrgId;
        }
        return config;
      }
    } catch {
      useApiLoadingStore.getState().decrement();
      throw new Error("Auth failed");
    }
    useApiLoadingStore.getState().decrement();
    window.location.href = "/login";
    return Promise.reject(new Error("Unauthorized"));
  },
);

export { api, plainApi };

export async function pingApi(): Promise<void> {
  await plainApi.get("/ping", { timeout: 5000 });
}
